import React, {useMemo} from 'react';

const UAlertMessage = (props) => {
    // Get Classnames
    const classNames = useMemo(() => {
        let classes = 'u_alert-message';

        if (props?.className) classes += ` ${props?.className}`;
        if (props?.danger) classes += ' u_alert-message-danger';
        if (props?.warning) classes += ' u_alert-message-warning';
        if (props?.info) classes += ' u_alert-message-info';
        if (props?.success) classes += ' u_alert-message-success';
        if (props?.full) classes += ' u_alert-message-full';

        return classes;
    }, [props]);

    return (
        <React.Fragment>
            <div className={classNames} style={props?.style}>
                {
                    props?.icon && <span className="u_alert-message-icon">
                        {props?.icon}
                    </span>
                }
                <p>{props?.children}</p>
            </div>
        </React.Fragment>
    )
};

export default UAlertMessage;
